import { CapoPlugin } from "D:/Out/MedCAT/MedCAT.Cms/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];